import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from './ThemeContext';
import { Phone, Mail, MapPin, Linkedin } from 'lucide-react';

const Footer = () => {
  const { theme } = useTheme();

  return (
    <footer
      style={{
        background: '#18181b',
        color: '#fff',
        padding: '0',
        boxShadow:
          theme === 'dark'
            ? '0 -2px 24px rgba(0,0,0,0.18)'
            : '0 -2px 24px rgba(255,102,0,0.08)',
        borderTopLeftRadius: 32,
        borderTopRightRadius: 32,
        marginTop: 48,
      }}
    >
      <div
        style={{
          maxWidth: 1200,
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
          gap: '2.5rem',
          alignItems: 'flex-start',
          padding: '48px 24px 24px 24px',
        }}
      >
        {/* Logo + Title + Tagline */}
        <div
          style={{
            minWidth: 240,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
          }}
        >
          {/* Logo and ETWiC Name */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 16,
              marginBottom: 16,
            }}
          >
            <img
              src={process.env.PUBLIC_URL + '/image.png'}
              alt="ETWiC Logo"
              style={{
                width: 110,
                height: 110,
                objectFit: 'contain',
                background: '#fff', // static white background for contrast
                borderRadius: 20,
                boxShadow: '0 4px 32px rgba(255,102,0,0.13)',
                border: '2px solid #FF6600',
                padding: 8,
                transition: 'box-shadow 0.2s',
                display: 'block',
              }}
              aria-label="ETWiC Logo"
            />
            <span
              style={{
                fontSize: '1.8rem',
                fontWeight: 800,
                color: '#FF6600',
                letterSpacing: 1,
              }}
            >
              ETWiC
            </span>
          </div>

          {/* Tagline */}
          <p
            style={{
              fontWeight: 600,
              fontSize: '1.05rem',
              lineHeight: 1.6,
              color: '#ddd',
              maxWidth: 280,
            }}
          >
            Empowering women, fortifying digital resilience, and shaping a safer
            cyber future for all.
          </p>
        </div>

        {/* ... (no changes to Quick Links, Programs, Contact sections) */}

        {/* Quick Links */}
        <div>
          <h4
            style={{
              fontWeight: 700,
              fontSize: '1.13rem',
              marginBottom: 14,
              letterSpacing: 0.2,
            }}
          >
            Quick Links
          </h4>
          <ul
            style={{
              listStyle: 'none',
              padding: 0,
              margin: 0,
              lineHeight: 2,
            }}
          >
            <li>
              <Link
                to="/about/OurTeam"
                style={{
                  color: '#fff',
                  textDecoration: 'none',
                  transition: 'color 0.18s',
                  fontWeight: 500,
                }}
                onMouseOver={(e) => (e.currentTarget.style.color = '#FF6600')}
                onMouseOut={(e) => (e.currentTarget.style.color = '#fff')}
              >
                Our Team
              </Link>
            </li>
            <li>
              <Link
                to="/programs/mentorship"
                style={{
                  color: '#fff',
                  textDecoration: 'none',
                  transition: 'color 0.18s',
                  fontWeight: 500,
                }}
                onMouseOver={(e) => (e.currentTarget.style.color = '#FF6600')}
                onMouseOut={(e) => (e.currentTarget.style.color = '#fff')}
              >
                Programs
              </Link>
            </li>
            <li>
              <Link
                to="/joinus/student-chapter"
                style={{
                  color: '#fff',
                  textDecoration: 'none',
                  transition: 'color 0.18s',
                  fontWeight: 500,
                }}
                onMouseOver={(e) => (e.currentTarget.style.color = '#FF6600')}
                onMouseOut={(e) => (e.currentTarget.style.color = '#fff')}
              >
                Become a Member
              </Link>
            </li>
            <li>
              <Link
                to="/events"
                style={{
                  color: '#fff',
                  textDecoration: 'none',
                  transition: 'color 0.18s',
                  fontWeight: 500,
                }}
                onMouseOver={(e) => (e.currentTarget.style.color = '#FF6600')}
                onMouseOut={(e) => (e.currentTarget.style.color = '#fff')}
              >
                Events
              </Link>
            </li>
          </ul>
        </div>

        

        {/* Programs */}
        <div>
          <h4
            style={{
              fontWeight: 700,
              fontSize: '1.13rem',
              marginBottom: 14,
              letterSpacing: 0.2,
            }}
          >
            Programs
          </h4>
          <ul
            style={{
              listStyle: 'none',
              padding: 0,
              margin: 0,
              lineHeight: 2,
            }}
          >
            <li>
              <Link
                to="/programs/cybersecurity-basics"
                style={{
                  color: '#fff',
                  textDecoration: 'none',
                  transition: 'color 0.18s',
                  fontWeight: 500,
                }}
                onMouseOver={(e) => (e.currentTarget.style.color = '#FF6600')}
                onMouseOut={(e) => (e.currentTarget.style.color = '#fff')}
              >
                Cybersecurity Basics
              </Link>
            </li>
            <li>
              <Link
                to="/programs/ethical-hacking"
                style={{
                  color: '#fff',
                  textDecoration: 'none',
                  transition: 'color 0.18s',
                  fontWeight: 500,
                }}
                onMouseOver={(e) => (e.currentTarget.style.color = '#FF6600')}
                onMouseOut={(e) => (e.currentTarget.style.color = '#fff')}
              >
                Ethical Hacking
              </Link>
            </li>
            <li>
              <Link
                to="/programs/certification"
                style={{
                  color: '#fff',
                  textDecoration: 'none',
                  transition: 'color 0.18s',
                  fontWeight: 500,
                }}
                onMouseOver={(e) => (e.currentTarget.style.color = '#FF6600')}
                onMouseOut={(e) => (e.currentTarget.style.color = '#fff')}
              >
                Certification Programs
              </Link>
            </li>
            <li>
              <Link
                to="/programs/mentorship"
                style={{
                  color: '#fff',
                  textDecoration: 'none',
                  transition: 'color 0.18s',
                  fontWeight: 500,
                }}
                onMouseOver={(e) => (e.currentTarget.style.color = '#FF6600')}
                onMouseOut={(e) => (e.currentTarget.style.color = '#fff')}
              >
                Mentorship Programs
              </Link>
            </li>
            <li>
              <Link
                to="/joinus/student-chapter"
                style={{
                  color: '#fff',
                  textDecoration: 'none',
                  transition: 'color 0.18s',
                  fontWeight: 500,
                }}
                onMouseOver={(e) => (e.currentTarget.style.color = '#FF6600')}
                onMouseOut={(e) => (e.currentTarget.style.color = '#fff')}
              >
                Student Chapters
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h4
            style={{
              fontWeight: 700,
              fontSize: '1.13rem',
              marginBottom: 14,
              letterSpacing: 0.2,
            }}
          >
            Contact Us
          </h4>
          <div style={{ fontSize: 15, lineHeight: 1.8 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <Phone size={18} color="#FF6600" />
              <a
                href="tel:+251911677096"
                style={{
                  color: '#fff',
                  textDecoration: 'none',
                  fontWeight: 600,
                }}
              >
                +251 0911 677096
              </a>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
              <Mail size={18} color="#FF6600" />
              <a
                href="mailto:contact@etwic.org"
                style={{
                  color: '#fff',
                  textDecoration: 'none',
                  fontWeight: 600,
                }}
              >
                contact@etwic.org
              </a>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
              <MapPin size={18} color="#FF6600" />
              <span style={{ color: '#fff', fontWeight: 600 }}>
                Addis Ababa, Ethiopia
              </span>
            </div>
            {/* Follow Us */}
            <div style={{ marginTop: 16 }}>
              <h5
                style={{
                  fontWeight: 700,
                  fontSize: '1.0rem',
                  marginBottom: 10,
                  letterSpacing: 0.2,
                }}
              >
                Follow Us
              </h5>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12, width: '100%' }}>
                {/* TODO: Replace the URL below with your real LinkedIn page URL */}
                <a
                  href="https://www.linkedin.com/company/ethiopian-women-in-cybersecurity"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 40,
                    height: 40,
                    borderRadius: 12,
                    border: '1px solid #FF6600',
                    color: '#FF6600',
                    cursor: 'pointer',
                    textDecoration: 'none',
                    transition: 'all 0.18s',
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.background = '#FF6600';
                    e.currentTarget.style.color = '#ffffff'; // keep icon visible using currentColor
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.background = 'transparent';
                    e.currentTarget.style.color = '#FF6600';
                  }}
                >
                  {/* Icon inherits currentColor so it stays visible on hover */}
                  <Linkedin size={20} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer bottom */}
      <div
        style={{
          borderTop: '1px solid #23242b',
          marginTop: 36,
          paddingTop: 18,
          textAlign: 'center',
          fontSize: 14,
          color: '#aaa',
          letterSpacing: 0.2,
        }}
      >
        Copyright © 2025 Ethiopian Women in Cybersecurity—ETWiC. All Rights
        Reserved
      </div>
    </footer>
  );
};

export default Footer;
